<template>
  <ul class="nav nav-tabs fontSize20" id="myTab" role="tablist">
    <li
      v-for="tab in filteredTabs"
      :key="tab.name"
      class="nav-item tab"
      :class="{ active: tab.name === activeTab }"
    >
      <a class="nav-link" role="tab" @click="onTab(tab)">{{ tab.title }}</a>
    </li>
  </ul>
</template>

<script>
import { mapMutations } from 'vuex'
import { tabList } from '@/constants/transaction'
import { hasTeamRole } from '@/utils/teamRoleAuth'

export default {
  data() {
    return {
      activeTab: 'instant',
    }
  },
  computed: {
    // 過濾顯示的標籤頁，根據條件決定是否顯示機場接送
    filteredTabs() {
      return this.TABS.filter((tab) => {
        // 機場接送選項需要滿足特定條件才顯示
        if (tab.name === 'airport') {
          return this.isShowAirportTransfer()
        }
        // 其他選項正常顯示
        return true
      })
    },
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setActiveTab: 'setActiveTab',
    }),
    onTab(tab) {
      this.vx_setActiveTab(tab.name)
      this.activeTab = tab.name
    },
    // 判斷是否顯示機場接送選項
    isShowAirportTransfer() {
      // 使用 teamRoles 權限檢查
      return hasTeamRole('airport_transfer')
    },
  },
  created() {
    this.TABS = tabList
  },
}
</script>

<style lang="scss" scoped>
.tab:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/components/TabNav.vue